import axios from 'axios'
import {wa1, wa2} from '/packages/pkg/wawa'
import { getToken, removeToken } from '@/utils/token'
const aiAxios = axios.create({
  baseURL: process.env.VUE_APP_REQUEST_BASE_URL,
  timeout: 0
})

const getCheck = async () => {
  try {
    // 第一步：调用wa1接口
    const res = await fetch(`${process.env.VUE_APP_REQUEST_BASE_URL}/api/wa1`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(wa1())
    })
      .then(res => res.json())
      .then(json => json.data)
    return JSON.stringify(wa2(res))
  } catch (e) {
    console.log(e)
  }
}

aiAxios.interceptors.request.use(async config => {
  const token = getToken()
  if (token) {
    config.headers['token'] = getToken()
  }
  config.headers['x-wa-check'] = await getCheck()
  return config
})

aiAxios.interceptors.response.use(response => {
  /**
   * TODO token失效处理
   */
  if (response.data.status === 401 || response.data.status === 2000) {
    removeToken()
    window.location.reload()
  }
  return response
})

export default aiAxios
